//   async function fetchCart() {
//     try {
//       console.debug("Fetching cart.............");

//       const response = await fetch('/cart.js');

//       if (!response.ok) {
//         throw new Error(`Cart fetch failed! Status: ${response.status}`);
//       }
//       //alert();
//       const cart = await response.json();

//       console.debug('Cart sent!', cart);
//       console.debug('Webhook POST sent!');

//       //alert('Cart fetched successfully');

//       return cart;

//     } catch (err) {
//       console.error('Cart.js error:', err);
//       return null;
//     }
//   }

// async function fetchDiscount(discountCode) {
//   try {
//     const response = await fetch('https://integrations.playermaker.co.uk/webhook/pm-discount-data', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json'
//       },
//       body: JSON.stringify({ discount: discountCode })
//     });
//     // const data2 = response.json();
//     // console.log("response", data2) 

//     // if (!response.ok) {
//     //   throw new Error(`HTTP error! Status: ${response.status}`);
//     // } 

//     const data = await response.json();
//     console.debug("response discount", data)
//     return data;

//   } catch (err) {
//     console.error('Error fetching discount:', err);
//     return null;
//   }
// }
// console.debug("page loading not complete");

// document.addEventListener('DOMContentLoaded', async function () {
//   try {
//     console.debug("page loading complete")
//     const cartData = await fetchCart();
//     // console.log(cartData);
//     console.debug("card completed!!!!!!!!")

//     const response = await fetchDiscount("100offambassador");
//     console.debug('Discount response:', response);
//   } catch (err) {
//     console.debug("error on page load", err);
//   }
// });

async function fetchCart() {
    try {
      console.debug("Fetching cart...");

      const response = await fetch('/cart.js');
      if (!response.ok) throw new Error(`Cart failed: ${response.status}`);

      const cart = await response.json();
      console.debug("Cart data:", cart);

      return cart;
    } catch (err) {
      console.error("Cart.js error:", err);
      return null;
    }
  }

  async function fetchDiscount(discountCode) {
    try {
      console.debug("Sending discount to webhook:", discountCode);

      const response = await fetch(
        'https://integrations.playermaker.co.uk/webhook/pm-discount-data',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: discountCode })
        }
      );
      console.debug("Sending discount to response:", response);

      const data = await response.json();
      console.debug("Webhook response:", data);
      return data;

    } catch (err) {
      console.error("Discount webhook error:", err);
      return null;
    }
  }

document.addEventListener("DOMContentLoaded", async () => {
    try {
      console.debug("Page loaded...");

      const cartData = await fetchCart();
      if (!cartData) return;

      const discountObj = cartData.discount_codes?.[0];

      if (!discountObj) {
        console.debug("No discount code in cart");
        return;
      }

      const discountCode = discountObj.code;
      const response = await fetchDiscount(discountCode);
      const discountAmount = response?.discount?.[0]?.discount?.customerGets?.value?.amount?.amount;
     
      if (discountAmount) {

        const els = document.querySelectorAll(".cart_discount_main");
        els.forEach(el => {
          el.classList.add("flex-discount");
        });

        const el = document.querySelector(".select-membership-cart-discount-main");
        const discountEl = el.querySelector('.discount_value');
        const discountCents = Math.round(parseFloat(discountAmount) * 100);
        discountEl.innerHTML = Shopify.formatMoney(discountCents,window.Money_Filter).replace('.00', '').replace(',00', '');

        const priceEls = document.querySelectorAll('.price_main_product_discount');
        priceEls.forEach(priceEl => {
          const originalCents = parseInt(priceEl.dataset.price, 10);
          const discountCents = Math.round(parseFloat(discountAmount) * 100);

          const finalCents = Math.max(0, originalCents - discountCents);
          priceEl.dataset.discount = discountCents;

          const formattedPrice = Shopify.formatMoney(
            finalCents,
            window.Money_Filter
          )
            .replace('.00', '')
            .replace(',00', '');

          priceEl.innerHTML = formattedPrice;
        });
        
      }

      const discountPercentage = response?.discount?.[0]?.discount?.customerGets?.value.percentage;
      if (discountPercentage) {
        const els = document.querySelectorAll(".cart_discount_main");
        els.forEach(el => el.classList.add("flex-discount"));

        const discountWrap = document.querySelector(".select-membership-cart-discount-main");
        const discountEl = discountWrap?.querySelector('.discount_value');
        var get_discount = discountPercentage*100;
        discountEl.innerHTML =  get_discount + '%';

        const priceEls = document.querySelectorAll('.price_main_product_discount');
        if (!priceEls.length) return;

        priceEls.forEach(priceEl => {
          const originalCents = parseInt(priceEl.dataset.price, 10);
          if (isNaN(originalCents)) return;

          const discountCents = Math.round(originalCents * discountPercentage);
          const finalCents = Math.max(0, originalCents - discountCents);

          priceEl.dataset.discount = discountCents;

          const formattedPrice = Shopify.formatMoney(
            finalCents,
            window.Money_Filter
          )
            .replace('.00','')
            .replace(',00','');

          priceEl.innerHTML = formattedPrice;
        });
      }
      
    } catch (err) {
      console.error("Page error:", err);
    }
});

